import { call } from 'redux-saga/effects';

import { DefaultCPPostMessagesType } from '../types';
import { incomingCPPostMessages } from '../consts';

import { handleCPNotification } from './handleNotification';

export function* defaultCPPostMessageHandler(
  postMessage: DefaultCPPostMessagesType
) {
  switch (postMessage.message) {
    case incomingCPPostMessages.notification: {
      yield call(handleCPNotification, postMessage.data);
      break;
    }
    default: {
      const { message } = postMessage;

      console.warn(`Cannot find handler for message=${message}`);
    }
  }
}
